import * as fetchCurrentAccount from 'store/actions/accounts/fetchCurrentAccount';
import * as updateCurrentAccount from 'store/actions/accounts/updateCurrentAccount';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import utils from 'helpers/utils';

function* fetchCurrentAccountAsync() {
    try {
        const url = `${ config.getApiBaseUrl() }/current-account`;

        const response = yield apiClient.read(url);

        yield put(fetchCurrentAccount.fetchCurrentAccountSuccess(response));
    } catch (error) {
        yield put(fetchCurrentAccount.fetchCurrentAccountFailure(error));
    }
}

function* updateCurrentAccountAsync({ payload }) {
    const {
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/current-account`;
        const response = yield apiClient.patch(url, values);

        yield put(updateCurrentAccount.updateCurrentAccountSuccess(response));

        if (utils.isFunction(onSuccess)) {
            yield onSuccess(response);
        }
    } catch (error) {
        yield put(updateCurrentAccount.updateCurrentAccountFailure(error));

        if (utils.isFunction(onError)) {
            yield onError(error);
        }
    }
}

function* updateCurrentAccountSuccessAsync() {
    yield put(showNotification('notifications.accounts.update.success'));
}

function* failureMessage({ payload }) {
    const { message } = payload.response;

    if (!message) {
        return;
    }

    yield put(showNotification(message, 'warning'));
}

export default function* currentAccountSagas() {
    yield [
        takeEvery(types.FETCH_CURRENT_ACCOUNT, fetchCurrentAccountAsync),
        takeEvery(types.FETCH_CURRENT_ACCOUNT_FAILURE, failureMessage),

        takeEvery(types.UPDATE_CURRENT_ACCOUNT, updateCurrentAccountAsync),
        takeEvery(types.UPDATE_CURRENT_ACCOUNT_FAILURE, failureMessage),
        takeEvery(types.UPDATE_CURRENT_ACCOUNT_SUCCESS, updateCurrentAccountSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/currentAccountSagas.js